import { post, postJson, url_domain, url_pre, get } from "@/plugins/api"
import { add, sub, mul, div, formatNumber } from "@/plugins/operation"


export function com_15s_price(pair, side, amount) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/transaction/com_15s_price?pair=${pair}&side=${side}&amount=${amount}`)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function common_tras_pairs(data) {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/transaction/com_trans_pair?side=${data.side}`)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function web_price() {
    return new Promise((resolve, reject) => {
        get(`${url_domain()}${url_pre()}/web/otc/temp_price`)
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function convertPrice(orgAmount, fxRate) {
    return mul(orgAmount, fxRate)
}

export function sumPrice(amountList, priceList, targetSymbol, fixed = 4) {
    // let _sumpri = 0
    // let tartPriInfo = 1
    // for (var i = 0; i < amountList.length; i++) {
    //     let _amount = amountList[i]

    //     for (var j = 0; j < priceList.length; j++) {
    //         let _priceinfo = priceList[j]
    //         if (_priceinfo.coin == targetSymbol) {
    //             tartPriInfo = _priceinfo.price
    //         }
    //         if (_priceinfo.coin == _amount.symbol) {
    //             _sumpri = add(_sumpri, mul(_amount.available, _priceinfo.price))
    //         }
    //     }
    // }
    // if (targetSymbol.indexOf('USD') > -1) {
    //     tartPriInfo = 1
    // }
    // return formatNumber(div(_sumpri, tartPriInfo), fixed, ',')
}